import Price, { PriceText } from 'components/Price';
import Text from 'components/Text';
import type { ProductPrice } from 'models/price';
import { cn } from 'utils/classNames';

interface Props {
	className?: string;
	volumePrice: ProductPrice;
	volumePriceLabel?: string;
}

export default function Staffling({
	className,
	volumePrice,
	volumePriceLabel,
}: Props) {
	const { comparisonPrice, title } = volumePrice;

	return (
		<div
			className={cn(
				'flex items-center justify-between gap-4 rounded-xs bg-information p-4 forced-colors:border',
				className,
			)}
		>
			<div>
				<Text as="p" className="font-bold">
					{title}
				</Text>
				{comparisonPrice?.title && (
					<PriceText
						as="p"
						price={comparisonPrice}
						prefix={comparisonPrice.title}
						className="mt-1 text-sm"
					/>
				)}
			</div>
			<div>
				<Price
					price={volumePrice}
					label={volumePriceLabel}
					size="sm"
					forceRegularPrice
					className="text-right"
				/>
			</div>
		</div>
	);
}
Staffling.displayName = 'Staffling';
